import React, { FunctionComponent } from "react";
import { WeatherForecastType, WeatherParameters } from "../../../../api/mosaicApi";

interface WeatherWidgetListItemProps {
    parameters: WeatherParameters;
    name?: string;
}

const getForecastTypeName = (type?: WeatherForecastType): string => {
    switch (type) {
        case WeatherForecastType.Hourly:
            return 'Hourly';
        case WeatherForecastType.Daily:
            return 'Daily';
        default:
            return 'Hourly';
    }
};

export const WeatherWidgetListItem: FunctionComponent<WeatherWidgetListItemProps> = ({ parameters, name }) => {
    const pollenTypes: string[] = [];
    if (parameters.showGrassPollen) pollenTypes.push('Grass');
    if (parameters.showBirchPollen) pollenTypes.push('Birch');
    if (parameters.showRagweedPollen) pollenTypes.push('Ragweed');
    if (parameters.showAlderPollen) pollenTypes.push('Alder');
    if (parameters.showMugwortPollen) pollenTypes.push('Mugwort');
    if (parameters.showOlivePollen) pollenTypes.push('Olive');

    return (
        <>
            <p>City: {parameters.city}</p>
            {name && <p>Name: {name}</p>}
            
            {/* Background Image */}
            {parameters.noBackground && <p>No Background: Yes</p>}
            {parameters.backgroundImageUrl && (
                <img 
                    className="mosaic-img" 
                    src={parameters.backgroundImageUrl} 
                    alt="Background" 
                    style={{ maxHeight: '60px', width: 'auto', objectFit: 'contain', marginBottom: '5px' }} 
                />
            )}
            
            {/* Basic Settings */}
            {parameters.showCurrentWeather === false && <p>Show Current Weather: No</p>}
            {parameters.showForecast === false && <p>Show Forecast: No</p>}
            {parameters.forecastType !== undefined && <p>Forecast Type: {getForecastTypeName(parameters.forecastType)}</p>}
            {parameters.itemCount !== undefined && <p>Item Count: {parameters.itemCount}</p>}
            {parameters.updateIntervalMinutes !== undefined && <p>Update Interval: {parameters.updateIntervalMinutes} min</p>}
            
            {/* Colors */}
            {parameters.textColour && <p>Text Color: {parameters.textColour}</p>}
            {parameters.backgroundColour && <p>Background Color: {parameters.backgroundColour}</p>}
            
            {/* Font Sizes - Current Weather */}
            {parameters.cityNameFontSize !== undefined && <p>City Name Font Size: {parameters.cityNameFontSize}</p>}
            {parameters.weatherDescriptionFontSize !== undefined && <p>Description Font Size: {parameters.weatherDescriptionFontSize}</p>}
            {parameters.currentTemperatureFontSize !== undefined && <p>Temperature Font Size: {parameters.currentTemperatureFontSize}</p>}
            {parameters.windFontSize !== undefined && <p>Wind Font Size: {parameters.windFontSize}</p>}
            {parameters.aqiFontSize !== undefined && <p>AQI Font Size: {parameters.aqiFontSize}</p>}
            
            {/* Font Sizes - Forecast */}
            {parameters.forecastTimeFontSize !== undefined && <p>Forecast Time Font Size: {parameters.forecastTimeFontSize}</p>}
            {parameters.forecastTempFontSize !== undefined && <p>Forecast Temp Font Size: {parameters.forecastTempFontSize}</p>}
            
            {/* Icon Sizes */}
            {parameters.currentIconSize !== undefined && <p>Current Icon Size: {parameters.currentIconSize}</p>}
            {parameters.forecastIconSize !== undefined && <p>Forecast Icon Size: {parameters.forecastIconSize}</p>}
            
            {/* Padding & Spacing */}
            {parameters.leftPadding !== undefined && <p>Left Padding: {parameters.leftPadding}</p>}
            {parameters.spaceBetweenCurrentWeatherAndAirQuality !== undefined && <p>Space (Weather - AQI): {parameters.spaceBetweenCurrentWeatherAndAirQuality}</p>}
            {parameters.spaceBetweenAirQualityAndForecast !== undefined && <p>Space (AQI - Forecast): {parameters.spaceBetweenAirQualityAndForecast}</p>}
            
            {/* AQI */}
            {parameters.showAqi && <p>Show AQI: Yes</p>}
            
            {/* Pollen */}
            {pollenTypes.length > 0 && <p>Pollen: {pollenTypes.join(', ')}</p>}
        </>
    );
};

export default WeatherWidgetListItem;
